"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8 0.667969C3.582 0.667969 0 4.24997 0 8.66797C0 10.1688 0.421561 11.568 1.14062 12.7682L0.0716146 16.668L4.05469 15.6224C5.21957 16.2847 6.56433 16.668 8 16.668C12.418 16.668 16 13.086 16 8.66797C16 4.24997 12.418 0.667969 8 0.667969ZM5.26172 4.9362C5.39172 4.9362 5.52529 4.93541 5.64063 4.94141C5.78329 4.94474 5.93857 4.95519 6.08724 5.28385C6.26391 5.67452 6.64858 6.65457 6.69792 6.75391C6.74725 6.85324 6.78221 6.97026 6.71354 7.10026C6.64821 7.23359 6.61423 7.31429 6.51823 7.43229C6.4189 7.54696 6.31005 7.68938 6.22005 7.77604C6.12072 7.87538 6.01815 7.98429 6.13281 8.18229C6.24748 8.38029 6.64571 9.02939 7.23437 9.55339C7.99104 10.2294 8.62946 10.4371 8.82812 10.5365C9.02679 10.6358 9.14184 10.6203 9.25651 10.487C9.37451 10.357 9.75208 9.91091 9.88542 9.71224C10.0154 9.51357 10.1481 9.54795 10.3281 9.61328C10.5108 9.67861 11.4849 10.1585 11.6836 10.2578C11.8823 10.3571 12.0125 10.4063 12.0625 10.487C12.1138 10.5703 12.1139 10.967 11.9492 11.4297C11.7846 11.8917 10.9759 12.3385 10.6133 12.3698C10.2473 12.4038 9.90571 12.5343 8.23438 11.8763C6.21838 11.0823 4.94699 9.01745 4.84766 8.88412C4.74832 8.75412 4.04036 7.81057 4.04036 6.83724C4.04036 5.86057 4.55244 5.38226 4.73177 5.18359C4.91444 4.98493 5.12839 4.9362 5.26172 4.9362Z",
    fill: fill
  }));
};

exports["default"] = _default;